import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { EmployeeExperience, EmployeeExperienceCreate, EmployeeExperienceFilter } from '../data/employeeExperience';

export function createEmployeeExperienceService(client: AxiosInstance) {
  return createCrudService<EmployeeExperience, EmployeeExperienceCreate, EmployeeExperienceFilter>(
    client,
    '/hrm/EmployeeExperience',
    'id',
  );
}

export type EmployeeExperienceService = CrudService<EmployeeExperience, EmployeeExperienceCreate, EmployeeExperienceFilter>;
